import React from 'react';

import { Platform } from 'react-native';

import { Helmet } from 'components/helmet';
import { IImage } from 'generated/sanity-graphql';
import { fullBrandName } from 'utils/environment';

interface IStoreMeta {
  phoneNumber: string;
  city: string;
  state: string;
  postalCode: string;
  streetAddress: string;
  atCopy: string;
  image?: IImage;
}

interface ILdJsonRestaurant {
  '@context': 'http://schema.org';
  '@type': 'Restaurant';
  address: {
    '@type': 'PostalAddress';
    addressLocality: string;
    addressRegion: string;
    postalCode: string;
    streetAddress: string;
  };
  name: string;
  telephone: string;
  url: string;
  image?: string;
}

const StoreMetaForSEO: React.FC<React.PropsWithChildren<IStoreMeta>> = ({
  phoneNumber,
  city,
  state,
  postalCode,
  streetAddress,
  atCopy,
  image,
}) => {
  if (Platform.OS !== 'web') {
    return null;
  }

  const ldJsonRestauranData: ILdJsonRestaurant = {
    '@context': 'http://schema.org',
    '@type': 'Restaurant',
    address: {
      '@type': 'PostalAddress',
      addressLocality: city,
      addressRegion: state,
      postalCode,
      streetAddress,
    },
    name: `${fullBrandName()} ${atCopy} ${streetAddress}`,
    telephone: phoneNumber,
    url: window.location.href,
  };

  if (image) {
    ldJsonRestauranData.image = image?.asset?.url || undefined;
  }

  return (
    <Helmet>
      <title>{streetAddress}</title>
      <script type="application/ld+json">{JSON.stringify(ldJsonRestauranData)}</script>
    </Helmet>
  );
};

export default StoreMetaForSEO;
